// LIBRARIES
import styled from "styled-components";

//MISC;
import { SIZE, DEVICE_TYPE, MARGIN } from "constants/variables";

//ASETS
import cursorIcon from "assets/img/Cursor.png";

export const LegislationDetailContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 162px ${SIZE.max200} ${SIZE.max100} ${SIZE.max200};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding: 150px 0px ${SIZE.max65} 0px;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 150px 0px 0 0px;
  }
`;

export const BackToGuidesWrapper = styled.div<{ biggerCursor?: boolean }>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: ${MARGIN.max10};
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s ease-in-out;
  &:hover {
    opacity: 0.8;
    transition: 0.3s ease-in-out;
  }
`;
export const BackToGuidesImage = styled.img`
  margin-top: 4px;
  margin-right: 8px;
  width: 10px;
  height: 16px;
`;

export const BackToGuidesButton = styled.div`
  border: none;
  margin-bottom: ${MARGIN.max6};
  cursor: pointer;
`;

export const TitleWrapper = styled.div`
  // margin-top: 8px;
  margin-bottom: 24px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-top: 16px;
    margin-bottom: 16px;
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding: 0px ${SIZE.max100} 0px ${SIZE.max100};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 0px ${SIZE.max32} 0 ${SIZE.max32};
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${SIZE.max40} 0;
  gap: ${SIZE.max16};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding: ${SIZE.max40} ${SIZE.max100} ${SIZE.max40} ${SIZE.max100};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: ${SIZE.max40} ${SIZE.max32} ${SIZE.max40} ${SIZE.max32};
  }
`;
export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: ${SIZE.max32};
`;

export const SvgContainer = styled.div`
  height: auto;
  width: auto;
  margin-bottom: ${MARGIN.max32};
  opacity: 0.4;
  > svg {
    height: ${SIZE.max220};
    width: ${SIZE.max220};
  }
`;
